/* ==========================================================================
   Search form
 ========================================================================== */

const SearchFormHandler = {

    form: null,

    init: function () {

        SearchFormHandler.form = document.querySelector('.js-search-form');

        if(!isset(SearchFormHandler.form)) return;

        const searchLocation = SearchFormHandler.form.querySelector('.js-search-location');

        SearchFormHandler.form.addEventListener('submit', function (e) {
            if(searchLocation.value === '') {
                searchLocation.classList.add('c-select--alert');
                e.preventDefault();
            }
        });

        if(SearchFormHandler.form.classList.contains('js-search-form-on-change')) {
            const formFields = SearchFormHandler.form.querySelectorAll('select, input');
            for(let i = 0; i < formFields.length; i++) {
                const formField = formFields[i];
                formField.addEventListener('change', function () {
                    if(searchLocation.value !== '') {
                        SearchFormHandler.form.submit();
                    }
                });
            }
        }
    },
};

SearchFormHandler.init();